import { AuthProvider, GeneralProvider } from "./provider";
import { Elements } from "@stripe/react-stripe-js";
import { ThemeProvider } from "styled-components";
import { BrowserRouter } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
// import React, { useEffect } from "react";
import { Constants, Tools } from "./utils";
import Localization from "./localization";
import { LightTheme } from "./themes";
import { ConfigProvider } from "antd";
import { App as AntApp } from "antd";
import Router from "./router";

const stripePromise = loadStripe(Constants.Project.stripeApiKey);

function App() {
  // useEffect(() => {
  //   document.title = Localization.htmlHeader.title;
  //   document
  //     .querySelector('meta[name="description"]')
  //     .setAttribute("content", Localization.htmlHeader.desc);
  // }, []);

  return (
    <Elements
      stripe={stripePromise}
      options={{ locale: Localization.getLanguage() }}
    >
      <BrowserRouter>
        <div id="app">
          <GeneralProvider>
            <AuthProvider>
              <ThemeProvider
                theme={{
                  ...LightTheme,
                  mobile: (_) =>
                    `@media (max-width: ${Tools.getCssVar(
                      "mobile-breakpoint"
                    )}) {${_}}`,
                }}
              >
                <ConfigProvider theme={LightTheme}>
                  <AntApp>
                    <Router />
                  </AntApp>
                </ConfigProvider>
              </ThemeProvider>
            </AuthProvider>
          </GeneralProvider>
        </div>
      </BrowserRouter>
    </Elements>
  );
}

export default App;
